export const CertificateShareOptions = [
    {
        id: 1,
        option: 'Individual Share',
        labelKey: 'CORE.ENUMS.SHARE_CERTIFICATE_OPTIONS.INDIVIDUAL_SHARE',
        value: 'Individual Share',
        icon: 'assets/v2/icons/user.svg'
    },
    {
        id: 2,
        option: 'Request Confirmation',
        labelKey: 'CORE.ENUMS.SHARE_CERTIFICATE_OPTIONS.REQUEST_CONFIRMATION',
        value: 'Request Confirmation',
        icon: 'assets/v2/icons/institution.svg'
    },
]